import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getBaseUrl } from '../../reducers';
import { getOrganizations } from "requesters/organizationRequester"
import EmailValidator from "email-validator";
import { Button, Modal, Table } from 'react-bootstrap';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import _ from 'lodash';
import { FIELD_VALIDATIONS_ORGANIZATION } from './formErrors';
import { putOrganization } from "requesters/organizationRequester"

const OrganizationDuplicate = ({organizations=[], setShowMergeModal}) => {
    const baseUrl = useSelector(getBaseUrl);
    const [defaultOrg, setDefaultOrg] = useState({});
    const [orgs, setOrgs] = useState([]);
    const [searchOrganizations, setSearchOrganizations] = useState([]);
    const [errors, setErrors] = useState([])
    const [merging, setMerging] = useState(false);
    const { accountTypes } = useSelector(state => state.options)
    const accountTypeOptions = accountTypes.map(v => ({ value: v[0], label: v[1] }))

    useEffect(() => {
        const org_temp = organizations.sort((a,b) => parseInt(a.id,10) - parseInt(b.id,10))
        setOrgs(org_temp);
        setDefaultOrg(org_temp?.[0]?.attributes ?? {});
    }, [organizations]);

    const handleInputChange = (e, name, cell_value) => {
        if(e?.value){
            setDefaultOrg({ ...defaultOrg, accountType: e.value })
            return;
        }
        
        setDefaultOrg({ ...defaultOrg, [name || e.target.name]: e.target.value || cell_value || "" });
    }

    const handleRemoveOrg = (org_id) => {
        const filteredOrgs = orgs.filter(o => o.attributes.id !== org_id);
        setOrgs(filteredOrgs);
    }

    const handleChangeDefault = (org_id) => {
        const org = orgs.find(o => o.attributes.id === org_id);
        setDefaultOrg(org.attributes);
    }

    const loadOrganizations = async (inputVal) => {
        if (inputVal.trim().length <= 3) return [];
        const request = await getOrganizations(baseUrl, {
            by_keyword: inputVal,
        })
        const data = Object.values(_.get(request.response, "organization", {}))
        return data.map(o => ({ value: o.id, label: o.attributes.name, data: o }));
    }

    const filterOption = (canidadate, inputValue) => !orgs.map(o => o.attributes.id)?.includes(parseInt(canidadate.value, 10));

    const handleAddContactToDuplicate = () => {
        const newOrg = searchOrganizations.map(d => d.data)
        setSearchOrganizations([])
        setOrgs([...orgs, ...newOrg])
    }

    const validateForm = () => {
        const fields = (({address, name, email, accountType}) => ({address, name, email, accountType}))(defaultOrg);
        const cErrors = [];
        let validField = true;
        _.map(fields, (v, key) => {
            switch(key) {
                case 'email':
                    const validateEmail = EmailValidator.validate(v);
                    if(!validateEmail) {
                        validField = false;
                        cErrors.push(key)
                    }
                    break;
                default:
                    if(_.isEmpty(v)) {
                        validField = false;
                        cErrors.push(key)
                    }
            }
            console.log(key, validField)
        });
        setErrors(cErrors);
        return validField;
    }

    const errorMessage = (field) => {
        if(!errors.includes(field)) return null;
        const message = _.find(FIELD_VALIDATIONS_ORGANIZATION, ["field", field])
        return <div className='err-msg'>{message.message}</div>
    }

    const handleMergeOrganizations = async () => {
        if(!validateForm()) return;
        setMerging(true);
        const org_ids = orgs.filter(o => o.attributes.id !== defaultOrg.id).map(o => o.id);
        const {address, name, email, accountType} = (({address, name, email, accountType}) => ({address, name, email, accountType}))(defaultOrg);
        const values = {address, name, email, account_type: accountType, quote_app_organisation_id: qoaID, org_to_merge_ids: org_ids};
        console.log(values)
        putOrganization(baseUrl, defaultOrg?.id, values)
            .then(res => {
                if(res.status === 200){
                    window.location.reload();
                    setShowMergeModal(false);
                }
            })
            // eslint-disable-next-line no-console
            .catch(err => { console.log(err); setMerging(false); })
    }
    const qoaID = useMemo(() => _.min(orgs.map(o => parseInt(o.attributes.quoteAppOrganisationId, 10))) || "", [orgs]);
    const relatedJobs = useMemo(() => _.sum(orgs.map(c => c.attributes.jobServicesCount)), [orgs])
    return (<Modal show={true} onHide={() => setShowMergeModal(false)} size="xl">
        <Modal.Body>
            <Table striped bordered className="w-100 text-md">
                <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Address</th>
                        <th>Account Type</th>
                        <th>QAO ID</th>
                        <th>Related Jobs</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {orgs.map((org, idx) => {
                        return (<tr key={`org-dup-${idx}`}>
                            <td><input type='checkbox' checked={org.attributes.id === defaultOrg.id} onChange={() => handleChangeDefault(org.attributes.id)} /></td>
                            <td onClick={(e) => handleInputChange(e, "name", org.attributes.name)}>{org.attributes.name}</td>
                            <td onClick={(e) => handleInputChange(e, "email", org.attributes.email)}>{org.attributes.email}</td>
                            <td onClick={(e) => handleInputChange(e, "address", org.attributes.address)}>{org.attributes.address}</td>
                            <td onClick={(e) => handleInputChange(e, "accountType", org.attributes.accountType)}>{org.attributes.accountTypeLabel}</td>
                            <td>{org.attributes.quoteAppOrganisationId}</td>
                            <td>{org.attributes.jobServicesCount}</td>
                            <td>{defaultOrg.id !== org.attributes.id && <i className='bi bi-x-circle-fill text-danger' title="Remove Organization" onClick={() => handleRemoveOrg(org.attributes.id)} /> }</td>
                        </tr>)
                    })}
                    <tr><td colSpan={7}></td></tr>
                    <tr>
                        <td colSpan={7}>
                            <div className="d-flex justify-content-end">
                                <AsyncSelect cacheOptions defaultOptions loadOptions={loadOrganizations} size="sm" styles={{control: (styles) => ({...styles, width: 400})}} value={searchOrganizations} isMulti onChange={(E) => setSearchOrganizations(E)} filterOption={filterOption} />
                                <Button size="sm" onClick={handleAddContactToDuplicate}>Add Organization</Button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </Table>
            <div className="w-50 p-2">
                <div className="form-group row">
                    <label className="col-3 col-form-label">Email*</label>
                    <div className="col-9">
                        <input
                            name="email"
                            className="form-control"
                            type="text"
                            placeholder="Email"
                            value={defaultOrg?.email}
                            onChange={e => handleInputChange(e)} />
                        {errorMessage('email')}
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Name*</label>
                    <div className="col-9">
                        <input
                            name="name"
                            className="form-control"
                            type="text"
                            placeholder="Name"
                            value={defaultOrg?.name}
                            onChange={e => handleInputChange(e)} />
                        {errorMessage('name')}
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Address*</label>
                    <div className="col-9">
                        <input
                            name="address"
                            className="form-control"
                            type="text"
                            placeholder="Address"
                            value={defaultOrg?.address}
                            onChange={e => handleInputChange(e)} />
                        {errorMessage('address')}
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Account Type *</label>
                    <div className="col-9">
                        <Select
                            name="accountType"
                            placeholder="Select"
                            value={_.filter(accountTypeOptions, ["value", defaultOrg?.accountType])}
                            options={accountTypeOptions}
                            onChange={e => handleInputChange(e)} />
                        
                        {errorMessage('accountType')}
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">QAO ID</label>
                    <div className="col-9">
                        {qoaID}
                        {/* {orgs?.quoteAppOrganisationId} */}
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-3 col-form-label">Related Jobs</label>
                    <div className="col-9">
                        {relatedJobs}
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outlined-blue" onClick={() => setShowMergeModal(false)}>Cancel</Button>
            <Button variant="red" onClick={handleMergeOrganizations} disabled={merging || orgs.length <= 1}>Merge</Button>
        </Modal.Footer>
    </Modal>);
}
export default OrganizationDuplicate;